import SuccessCheckout from './SuccessCheckout';

export default SuccessCheckout;
